import { Checkbox, Form, TimePicker } from "antd";
import arLocale from "antd/es/date-picker/locale/ar_EG";
import enLocale from "antd/es/date-picker/locale/en_US";
import dayjs from "dayjs";
import { useState } from "react";
import { useIntl } from "react-intl";
const formatTime = "hh:mm A";

const WorkingsHoursEdit = ({
  day,
  opening_time,
  closing_time,
  index,
  form,
  off,
}: any) => {
  const hoursFromTimeString = parseInt(opening_time.split(":")[1], 10);
  const minFromTimeString = parseInt(opening_time.split(":")[2], 10);
  console.log(hoursFromTimeString, "hoursFromTimeString");
  console.log(opening_time, "opening_time");

  const [componentDisabled, setComponentDisabled] = useState<boolean>(off);
  const [openingTime, setOpeningTime] = useState<any>(
    dayjs().hour(+hoursFromTimeString).minute(minFromTimeString)
  );
  const handleOpeningTimeChange = (time: any) => {
    console.log(time);
    // Assuming `time` is a moment object; if not, convert it accordingly
    setOpeningTime(dayjs(time)); // Ensure it's a dayjs object if needed
  };
  const { locale } = useIntl();
  // Calculate disabled hours based on selected opening time
  const getDisabledHours = () => {
    const hours = [];
    if (openingTime) {
      // Use the .hour() method to get the hour from the openingTime 'dayjs' object
      const selectedHour = openingTime.hour();
      // Assuming you want to allow selecting the same hour but later minutes,
      // start disabling hours from the next hour onwards
      for (let i = 0; i < selectedHour; i++) {
        hours.push(i);
      }
    }
    return hours;
  };
  const intl = useIntl();
  return (
    <div className="w-full">
      <div
        key={index}
        className={`w-full flex flex-col items-start justify-start text-right ${
          componentDisabled ? "p-4" : "px-4"
        } `}
      >
        <Checkbox
          checked={!componentDisabled}
          onChange={() => setComponentDisabled(!componentDisabled)}
        >
          <span className={`${!componentDisabled || "text-[#75757E]"}`}>
            {day}
          </span>
        </Checkbox>
        {!componentDisabled ? (
          <Form.Item
            className={`${
              componentDisabled && "hidden"
            } p-2 rounded w-full text-color-primary !m-0`}
          >
            <div key={index} className="w-full flex items-center gap-2">
              <div className="gutter-row ">
                <Form.Item
                  required={false}
                  label={intl.formatMessage({ id: "openingTime.label" })}
                  name={["opening_hours", day, "opening_time"]}
                  initialValue={dayjs().hour(9).minute(0)}
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "openingTime.validationMessage",
                      }),
                    },
                  ]}
                >
                  <TimePicker
                    locale={locale === "ar" ? arLocale : enLocale}
                    placeholder={intl.formatMessage({
                      id: "openingTime.placeholder",
                    })}
                    onChange={handleOpeningTimeChange}
                    className="w-full my-input"
                    format={"h:mm"}
                    needConfirm={false}
                    minuteStep={5}
                  />
                </Form.Item>
              </div>
              <div className="gutter-row ">
                <Form.Item
                  required={false}
                  name={["opening_hours", day, "closing_time"]}
                  initialValue={dayjs().hour(17).minute(0)}
                  label={intl.formatMessage({ id: "closingTime.label" })}
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "closingTime.validationMessage",
                      }),
                    },
                  ]}
                >
                  <TimePicker
                    locale={locale === "ar" ? arLocale : enLocale}
                    disabledTime={() => ({
                      disabledHours: () => getDisabledHours(),
                    })}
                    placeholder={intl.formatMessage({
                      id: "closingTime.placeholder",
                    })}
                    className="w-full my-input"
                    // format={formatTime}
                    format={"h:mm"}
                    needConfirm={false}
                    minuteStep={5}
                  />
                </Form.Item>
              </div>
            </div>
          </Form.Item>
        ) : (
          <div className="py-2 rounded w-full text-[#75757E]">
            {intl.formatMessage({ id: "break" })}
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkingsHoursEdit;
